import { gql } from '@apollo/client';

export const ALL_CONTACT_LISTS = gql`
  query AllInstitutionContactUsers($id: ID!) {
    users: getInstitutionContactUsers(id: $id) {
      id
      firstName
      lastName
      email
      contactNumber
    }
  }
`;
